import { useCompanyProfileJobAdQuery, type CompanyProfileJobAdQuery } from '~api';

type ChildrenProps = {
  profile: CompanyProfileJobAdQuery['CompanyProfile']['publicProfileByUuid'];
  loading: boolean;
};

type Props = {
  uuid: string;
  children: (props: ChildrenProps) => React.ReactNode;
};

export const DataProvider = ({ uuid, children }: Props) => {
  const { data, loading } = useCompanyProfileJobAdQuery({
    variables: { uuid },
  });

  return children({ profile: data?.CompanyProfile.publicProfileByUuid, loading });
};
